import React from 'react';
import {X5LessonType, X5LessonTypeLabels, X5LessonTypes} from '../../../domain';
import {SingleMappingSelect} from './base/SingleMappingSelect';

type LessonTypeOption = {
  value: X5LessonType;
  label: string;
};

const LessonTypeOptions: LessonTypeOption[] =
  X5LessonTypes.map(lessonType => ({
    value: lessonType,
    label: X5LessonTypeLabels[lessonType]
  }));

function getOptionValue(option: LessonTypeOption) {
  return option.value;
}

function getOptionLabel(option: LessonTypeOption) {
  return option.label;
}

type LessonTypeSelectProps = {
  value: X5LessonType | null;
  onChange: (lessonType: X5LessonType | null) => void;
  onBlur?: () => void;
};

export class LessonTypeSelect extends React.Component<LessonTypeSelectProps> {
  render() {
    return (
      <SingleMappingSelect<LessonTypeOption, X5LessonType>
        options={LessonTypeOptions}
        value={this.props.value}
        getLabel={getOptionLabel}
        getValue={getOptionValue}
        onChange={this.props.onChange}
        onBlur={this.props.onBlur}/>);
  }
}
